export default {
  disabledStateBg: '#fff',
  disabledStateColor: '#c0392b',
  enabledStateBg: '#fff',
  enabledStateColor: '#27ae60'
}
